<div class="p-grid">
  <p-card class="p-col-3" styleClass="card-container" header="Focus areas">
    <ul>
      <li>
        <a
          href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
          target="_blank"
          >Javascript</a
        >
      </li>
      <li>
        <a href="https://angular.io/" target="_blank">Angular</a>
      </li>
      <li>
        <a href="https://reactjs.org/" target="_blank">React.js</a>
      </li>
      <li>
        <a href="https://nodejs.org/en/" target="_blank">Node.js </a>
      </li>
      <li>
        <a href=" https://www.mongodb.com/" target="_blank">MongoDB</a>
      </li>
      <li>
        <a href="https://spring.io/" target="_blank">Spring</a>
      </li>
    </ul>
  </p-card>
  <p-card
    class="p-col-3"
    styleClass="card-container"
    header="Software programming and architecture styles"
  >
    <ul>
      <li>
        <a href="https://12factor.net/" target="_blank"
          >The Twelve-Factor App</a
        >
      </li>
      <li>
        <a href="https://microservices.io/" target="_blank">Microservices</a>
      </li>
      <li>
        <a href="https://www.oodesign.com/" target="_blank"
          >OOAD and Design patterns</a
        >
      </li>
    </ul>
  </p-card>

  <p-card
    class="p-col-3"
    styleClass="card-container"
    header="Domians and protocols"
  >
    <ul>
      <li>
        <a href="https://www.websocket.org/" target="_blank">WebSocket</a>
      </li>
      <li>
        <a href="https://webrtc.org/" target="_blank">WebRTC</a>
      </li>
    </ul>
  </p-card>
  <p-card class="p-col-3" styleClass="card-container" header="Daily visits">
    <ul>
      <li>
        <a href="https://subscription.packtpub.com/" target="_blank"
          >Packtpub</a
        >
      </li>
      <li>
        <a href="https://css-tricks.com/" target="_blank">CSS tricks</a>
      </li>
      <li>
        <a href="https://dzone.com/" target="_blank">Dzone</a>
      </li>
      <li>
        <a href="https://vishwanathph.atlassian.net">myJira</a>
      </li>
    </ul>
  </p-card>
  <p-card class="p-col-3" styleClass="card-container" header="On Stage">
    <ul>
      <li>
        <a href="https://mailchimp.com/" target="_blank"
          >Mailchimp for mail related (SMTP)</a
        >
      </li>
      <!-- <li>
        <a href="https://css-tricks.com/" target="_blank">CSS tricks</a>
      </li> -->
    </ul>
  </p-card>
  <p-card
    class="p-col-3"
    styleClass="card-container"
    header="Frameworks , Tools and libraries"
  >
    <ul>
      <li>
        <a href="https://redux.js.org/">Redux</a>
      </li>
      <li>
        <a href="https://webpack.js.org/">Webpack</a>
      </li>
      <li>
        <a href="https://eslint.org/">ESlint</a>
      </li>
      <li>
        <a href="https://babeljs.io/">Babel</a>
      </li>
      <li>
        <a href="https://www.typescriptlang.org/">Typescript</a>
      </li>
      <li>
        <a href="https://www.ag-grid.com/">ag-Grid</a>
      </li>
    </ul>
  </p-card>

  <!-- <p-card class="p-col-4" header="My codebits">
    <ul>
      <li>
        <a href="https://subscription.packtpub.com/">Packtpub</a>
      </li>
    </ul>
  </p-card> -->
  <p-card class="p-col-3" header="My Bookmarks" styleClass="card-container">
    <app-technical-references></app-technical-references>
  </p-card>
  <!-- <p-card class="p-col-3" header="CI/CD" styleClass="card-container"> </p-card> -->

  <p-card
    class="p-col-3"
    styleClass="card-container"
    header="Interview Questions MCQ"
  >
    <ul>
      <li>
        <a href="https://www.onlineinterviewquestions.com/angular-2-mcq/"
          >Angular</a
        >
      </li>
      <li>
        <a href="https://www.vskills.in/practice/angular-6-mock-test"
          >Angular 6 mock test</a
        >
      </li>
      <li>
        <a href="https://www.vskills.in/practice/angular-7-practice-questions"
          >Angular 7 Practice Questions</a
        >
      </li>
      <!--<li>
        <a href=""
          ></a
        >
      </li>
      <li>
        <a href=""
          ></a
        >
      </li> 
      <li>
        <a href=""
          ></a
        >
      </li> -->
    </ul>
  </p-card>
</div>
